import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

const PrivacyPolicyPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back" onClick={() => navigate(-1)}>
          <i className="ri-arrow-left-line" /> Назад
        </button>

        <h1 className="legal-title">Политика обработки персональных данных</h1>
        <p className="legal-updated">Действует с 4 июля 2026 года · Ryaskov.pro</p>

        <div className="legal-content">
          <h2>1. Оператор персональных данных</h2>
          <p>
            Обработку персональных данных пользователей сервиса Ryaskov.pro (далее — «Сервис»)
            осуществляет <strong>Рясков Сергей Сергеевич</strong> (далее — «Оператор»), действующий
            как физическое лицо. Контакт по вопросам обработки персональных данных:{' '}
            <strong>mail@ryaskov.pro</strong>.
          </p>

          <h2>2. Настоящая политика составлена в соответствии с</h2>
          <p>
            Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и разработана
            в целях обеспечения прав пользователей Сервиса при обработке их персональных данных.
          </p>

          <h2>3. Какие данные обрабатываются</h2>
          <p>При регистрации и использовании Сервиса Оператор обрабатывает:</p>
          <ul>
            <li>имя и фамилию;</li>
            <li>адрес электронной почты и/или номер телефона;</li>
            <li>пароль (хранится в необратимо хешированном виде — Оператор не имеет доступа к паролю в открытом виде);</li>
            <li>данные, которые пользователь вносит в Сервис в ходе работы (сведения об объектах, сменах, платежах и связанной хозяйственной деятельности);</li>
            <li>технические данные (IP-адрес, данные об устройстве и браузере, журналы действий) — в объёме, необходимом для работы и защиты Сервиса.</li>
          </ul>

          <h2>4. Цели обработки</h2>
          <ul>
            <li>регистрация и идентификация пользователя в Сервисе;</li>
            <li>предоставление функциональности Сервиса (учёт смен, объектов, платежей и т.п.);</li>
            <li>направление технических уведомлений и кодов подтверждения на email;</li>
            <li>обеспечение безопасности и предотвращение несанкционированного доступа;</li>
            <li>исполнение требований законодательства РФ.</li>
          </ul>

          <h2>5. Правовые основания обработки</h2>
          <p>
            Обработка осуществляется на основании согласия субъекта персональных данных
            (ст. 9 152-ФЗ), предоставляемого при регистрации, а также в случаях, предусмотренных
            законодательством РФ.
          </p>

          <h2>6. Хранение и трансграничная передача данных</h2>
          <p>
            Персональные данные пользователей хранятся на сервере, физически расположенном
            на территории Российской Федерации. Трансграничная передача персональных данных
            Оператором не осуществляется.
          </p>

          <h2>7. Срок хранения</h2>
          <p>
            Данные хранятся в течение всего периода использования Сервиса пользователем.
            При удалении аккаунта или отзыве согласия данные удаляются или обезличиваются
            в срок, необходимый для завершения технических процедур, но не позднее 30 дней,
            за исключением случаев, когда более длительное хранение требуется законодательством РФ.
          </p>

          <h2>8. Передача данных третьим лицам</h2>
          <p>
            Оператор не передаёт персональные данные третьим лицам, за исключением технических
            подрядчиков, обеспечивающих функционирование Сервиса (например, сервис отправки
            электронной почты), и случаев, предусмотренных законодательством РФ.
          </p>

          <h2>9. Права субъекта персональных данных</h2>
          <p>Пользователь вправе:</p>
          <ul>
            <li>получить информацию об обработке своих персональных данных;</li>
            <li>требовать уточнения, блокирования или уничтожения своих данных, если они неполны, устарели, недостоверны или обрабатываются незаконно;</li>
            <li>отозвать согласие на обработку персональных данных в любой момент;</li>
            <li>обратиться с жалобой в уполномоченный орган по защите прав субъектов персональных данных (Роскомнадзор).</li>
          </ul>
          <p>
            Для реализации этих прав обращайтесь по адресу <strong>mail@ryaskov.pro</strong>.
          </p>

          <h2>10. Меры защиты данных</h2>
          <p>
            Оператор применяет организационные и технические меры для защиты персональных данных:
            хеширование паролей, ограничение доступа к базе данных, использование защищённого
            соединения (HTTPS) при передаче данных.
          </p>

          <div className="legal-highlight">
            <p>
              Регистрируясь в Сервисе, вы подтверждаете, что ознакомлены с настоящей политикой
              и даёте согласие на обработку своих персональных данных на указанных условиях.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
